import React from "react";

export default (props) => (
  <section
    className="content-header flex-wrap"
    style={{
      marginTop: props.semTitulo ? "-20px" : "-10px",
      marginLeft: "-5px",
    }}
  >
    {!props.semTitulo && (
      <h1 className={props.titleClass}>
        {props.title} <small>{props.small}</small>
      </h1>
    )}
  </section>
);



// WEBPACK FOOTER //
// ./src/lib_react_adminlte/template/content/ContentHeader.jsx